import React, { useMemo } from "react";

import { Node } from "../";

import type { EnvironmentTreeData } from "../utils";

type NodesProps = {
  nodes: EnvironmentTreeData[];
  organizationId: string;
  showEnvs: { active: boolean; inactive: boolean };
  titleFilter: string;
  visibleNodes?: string[];
  isBigScreen?: boolean;
};

const Nodes = ({
  nodes,
  organizationId,
  showEnvs,
  titleFilter,
  visibleNodes,
  isBigScreen
}: NodesProps) => {
  const list = useMemo(
    () =>
      nodes
        .sort((a, b) =>
          a.title.toLowerCase().localeCompare(b.title.toLowerCase())
        )
        .filter(node => visibleNodes?.includes(node.environmentId)),
    [nodes, visibleNodes]
  );

  if (!list.length) return null;
  return (
    <ol style={{ listStyle: "none" }}>
      {list.map(node => (
        <li key={`node-${node.environmentId}`}>
          <Node
            isBigScreen={isBigScreen}
            key={`node-${node.environmentId}`}
            node={node}
            organizationId={organizationId}
            showEnvs={showEnvs}
            titleFilter={titleFilter}
            visibleNodes={visibleNodes}
            aria-label={`node-${node.environmentId}`}
          />
        </li>
      ))}
    </ol>
  );
};

export default Nodes;
